<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="typeProduitSvc"></yo-generic-datagrid-pn>
